import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import * as actions from '../services/actions';
import { StoreState } from '@ui/store/rootReducer';
import { LoadableContent } from '@ui/components';
import { authSelectors } from '@ui/store/auth';
import { actions as metaActions } from '@ui/store/meta';
import { mainSelectors } from '..';
import Routes from '../../Routes';

import Content from '../components/Content';

import './Main.less';

interface DispatchToProps {
  onAppInit: () => void;
  onLoadMeta: () => void;
}

interface StateToProps {
  loading: boolean;
  ready: boolean;
  loggedIn: boolean;
}

type Props = StateToProps & DispatchToProps & RouteComponentProps;

class Main extends React.PureComponent<Props> {
  componentDidMount() {
    const { onAppInit, onLoadMeta } = this.props;
    onAppInit();
    onLoadMeta();
  }

  render() {
    const { loading, ready, loggedIn } = this.props;
    return (
      <LoadableContent loading={loading}>
        {ready && (
          <Content loggedIn={loggedIn}>
            <Routes />
          </Content>
        )}
      </LoadableContent>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  loading: mainSelectors.getLoading(state),
  ready: mainSelectors.getReady(state),
  loggedIn: authSelectors.getLoggedIn(state),
});

const mapDispatchToProps = {
  onAppInit: actions.mainRequested,
  onLoadMeta: metaActions.metaRequested,
};

export default withRouter(
  connect<StateToProps, DispatchToProps>(
    mapStateToProps,
    mapDispatchToProps,
  )(Main),
);



// WEBPACK FOOTER //
// ./src/Main/containers/Main.tsx